<script>
    // last modified by koqiui
    import { Utils, Jqext } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    let Toast = Jqext.Toast;

    //代码编辑器的格式化命令
    let code_editor_format_cmd = {
        name: 'Format',
        bindKey: {win: 'Ctrl-Shift+F', mac: 'Command-Shift+F'},
        exec: function (editor) {
            let language = editor.session.getMode().$id;
            language = language.substring(language.lastIndexOf('/') + 1);
            try {
                if(language == "json") {
                    let json = editor.session.getValue() || '';
                    json = JSON.decode(json);
                    json = JSON.format(json);
                    editor.session.setValue(json);
                }
                else if(language == "javascript") {
                    if(typeof js_beautify == 'function') {
                        let script = editor.session.getValue() || '';
                        script = js_beautify(script, {});
                        editor.session.setValue(script);
                    }
                    else {
                        console.warn('缺少 js_beautify 函数，可能没引入 beautify.js');
                    }
                }
                else if(language == "html") {
                    if(typeof html_beautify == 'function') {
                        let script = editor.session.getValue() || '';
                        script = html_beautify(script, {});
                        editor.session.setValue(script);
                    }
                    else {
                        console.warn('缺少 html_beautify 函数，可能没引入 beautify-html.js');
                    }
                }
                else if(language == "css") {
                    if(typeof css_beautify == 'function') {
                        let script = editor.session.getValue() || '';
                        script = css_beautify(script, {});
                        editor.session.setValue(script);
                    }
                    else {
                        console.warn('缺少 css_beautify 函数，可能没引入 beautify-css.js');
                    }
                }
            }
            catch(ex) {
                console.error(ex);
                Toast.show(language + ' 格式化失败', 5000, 'warning');
            }
        },
        readOnly: true // false if this command should not apply in readOnly mode
        // multiSelectAction: "forEach", optional way to control behavior with multiple cursors
        // scrollIntoView: "cursor", control how cursor is scolled into view after the command
    };

    export default {
        name: 'swb-code-editor',
        desc: 'ace 代码编辑器',

        template: '<pre :style="{ width : toDimSizePx(width), height : toDimSizePx(height)}"></pre>',
        props: {
            text: {//文本初始对象（快捷属性）
                type: String,
                default: null
            },
            json: null, //json初始对象（快捷属性）
            //v-model双向绑定
            value: {
                type: String,
                default: ''
            },
            language: true,
            theme: null,
            height: '100%',
            width: '100%',
            options: {
                wrap: 'free'
            },
            //
            readonly: {
                type: Boolean,
                default: false
            },
            //
            fontsize: {
                type: Number,
                default: 12
            }
        },
        data: function () {
            return {
                editor: null,
                contentBackup: '',
                //
                defLanguage: 'text',
                defTheme: 'chrome'
            }
        },
        methods: {
            toDimSizePx: function (n) {
                n = n || '100%';
                n = n + '';
                if(n.lastIndexOf('%') == -1) {
                    if(/^\d*$/.test(n)) {
                        return n + "px";
                    }
                }
                return n;
            },
            markReadOnly: function () {
                this.editor.setReadOnly(this.readonly);
                this.editor.renderer.setShowGutter(!this.readonly);
            },
            encodeVal: function (val) {
                if(val == null) {
                    val = ''
                }
                if(typeof val != 'string') {
                    if(Utils.isPlainObject(val) || Utils.isArray(val)) {
                        val = JSON.format(val);
                    }
                    else {
                        val = val + '';
                    }
                }
                return val;
            },
            decodeVal: function (val) {
                if(this.language == 'json') {
                    if(typeof val == 'string') {
                        val = val.trim();
                        try {
                            return JSON.decode(val);
                        }
                        catch(ex) {
                            console.warn(ex);
                            //
                            return null;
                        }
                    }
                }
                return val;
            },
            getData: function () {
                let content = this.editor == null ? null : this.editor.getValue();
                return this.decodeVal(content);
            }
        },
        watch: {
            text: function (val) {
                if(this.contentBackup !== val) {
                    this.editor.session.setValue(val, -1);
                    this.contentBackup = val;
                }
            },
            json: function (val) {
                val = this.encodeVal(val);
                if(this.contentBackup !== val) {
                    this.editor.session.setValue(val, -1);
                    this.contentBackup = val;
                }
            },
            value: function (val) {
                if(this.contentBackup !== val) {
                    this.editor.session.setValue(val, -1);
                    this.contentBackup = val;
                }
            },
            language: function (newLang) {
                this.editor.session.setMode(typeof newLang == 'string' ? 'ace/mode/' + newLang : newLang);
            },
            theme: function (newTheme) {
                this.editor.setTheme('ace/theme/' + newTheme);
            },
            options: function (newOption) {
                this.editor.setOptions(newOption);
            },
            height: function () {
                this.$nextTick(function () {
                    this.editor.resize();
                })
            },
            width: function () {
                this.$nextTick(function () {
                    this.editor.resize();
                })
            },
            readonly: function (value) {
                this.markReadOnly();
            },
            fontsize: function (value) {
                if(value >= 8) {
                    this.editor.setFontSize(value);
                }
                else {
                    this.editor.setFontSize(12);
                }
            }
        },
        beforeDestroy: function () {
            if(this.editor != null) {
                this.editor.destroy();
                this.editor.container.remove();
            }
            this.editor = null;
            this.contentBackup = null;
            this.json = null;
            this.options = null;
        },
        mounted: function () {
            if(typeof ace == 'undefined') {
                this.$el.innerHTML = '';
                //
                throw '加载 ace 失败（请确认引入了相关的js）';
            }

            let editor = this.editor = ace.edit(this.$el, {
                mode: 'ace/mode/' + this.defLanguage,
                theme: 'ace/theme/' + this.defTheme
            });
            //默认行为
            editor.$blockScrolling = Infinity;
            editor.setShowPrintMargin(false);
            editor.session.setTabSize(4);
            editor.session.setUseSoftTabs(true);
            editor.session.setWrapLimitRange(120, 240);
            editor.session.setUseWrapMode(true);
            //
            this.markReadOnly();
            if(this.fontsize >= 8) {
                editor.setFontSize(this.fontsize);
            }

            //
            let language = this.language || this.defLanguage;
            let theme = this.theme || this.defTheme;
            editor.session.setMode(typeof language == 'string' ? 'ace/mode/' + language : language);
            editor.setTheme('ace/theme/' + theme);

            //自动加入格式化支持
            editor.commands.addCommand(code_editor_format_cmd);

            //加载自定义配置
            this.$emit('init', editor);

            //
            let value = this.json == null ? (this.text || this.value) : this.encodeVal(this.json);
            if(value) {
                editor.setValue(value, -1);
            }
            this.contentBackup = value;

            let self = this;
            //
            editor.on('change', function () {
                let content = editor.getValue();
                self.$emit('input', content);
                self.contentBackup = content;
            });

            if(this.options) {
                editor.setOptions(this.options);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/ctrl/CodeEditor.vue